import { createFileRoute } from "@tanstack/react-router";

import { BookSessionScreen } from "@/modules/coaching/book-sessions/screens/BookSessionScreen";
import { bookSessionLoader } from "@/modules/coaching/book-sessions/utils/bookSessionLoader";

export const Route = createFileRoute("/$sessionCode/book/")({
  loader: bookSessionLoader,
  component: BookSessionScreen,
});
